import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { AiCommandPaletteProvider, useAiCommandPalette } from './context/AiCommandPaletteContext';
import SearchInput from './components/SearchInput';
import SearchResults from './components/SearchResults';
import AiResults from './components/AiResults';
import KeyboardShortcuts from './components/KeyboardShortcuts';
import ErrorMessage from './components/ErrorMessage';
import Suggestions from './components/Suggestions';

// Import context helpers
import * as contextHelpers from './utils/contextHelpers';

// The actual command palette UI that uses the context
const CommandPaletteContent = ({ pageContext }) => {
  const { 
    isOpen, 
    onClose, 
    handleOverlayClick,
    isAskMode,
    conversationHistory,
    setSelectedIndex,
    setContextFromPage
  } = useAiCommandPalette();

  // Set context from page when command palette opens
  useEffect(() => {
    if (isOpen && pageContext) {
      setContextFromPage(pageContext);
    }
  }, [isOpen, pageContext, setContextFromPage]);

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div 
        className="fixed inset-0 bg-gray-100/40 dark:bg-black/50 backdrop-blur-md z-50"
        onClick={handleOverlayClick}
      >
        <motion.div 
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          exit={{ y: -20 }}
          className={`container max-w-3xl mx-auto ${isAskMode ? 'mt-[10vh]' : 'mt-[20vh]'} transition-[margin-top]`}
          onMouseLeave={() => setSelectedIndex(-1)}
        >
          <div 
            className="bg-white/80 dark:bg-black/60 backdrop-blur-xl rounded-2xl border border-violet-500 dark:border-violet-600 shadow-xl shadow-violet-500/10 overflow-hidden"
            onMouseMove={(e) => {
              // Only reset selection if mouse is directly on the container but not on a result item
              // This prevents erratic behavior when moving between options
              if (e.target === e.currentTarget) {
                setSelectedIndex(-1);
              }
            }}
          >
            {/* Input Section */}
            <SearchInput />

            {/* <Suggestions /> */}

            {/* Results Section */}
            <div className={`overflow-y-auto ${isAskMode ? 'max-h-[65vh]' : 'max-h-[40vh]'}`}>
              <ErrorMessage />
              
              {/* Show AI Results or Search Results based on mode */}
              {isAskMode || conversationHistory.length > 0 ? (
                <AiResults />
              ) : (
                <SearchResults />
              )}
            </div>
          </div>

          {/* Suggestions below the main palette */}
          <Suggestions />
          
          {/* Keyboard shortcuts help box */}
          {/* <KeyboardShortcuts /> */}
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

// The main component that provides the context
const AiCommandPalette = ({ isOpen, onClose, pageContext }) => {
  console.log('pageContext:', pageContext);
  return (
    <AiCommandPaletteProvider isOpen={isOpen} onClose={onClose}>
      <CommandPaletteContent pageContext={pageContext} />
    </AiCommandPaletteProvider>
  );
};

// Export context helpers alongside the component
export { contextHelpers };

export default AiCommandPalette; 